import { Anchor } from '@mantine/core';

const CONTACT_EMAIL = 'simon@kapa.ai';
const CONTACT_SUBJECT = 'Kapa Agent SDK — Help building an agent';
const CONTACT_BODY = `Hi Kapa team,

I'd like to discuss how to build an agent with the Kapa Agent SDK.

Could we set up a time to chat?

Thanks!`;

const contactMailtoHref = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  CONTACT_SUBJECT,
)}&body=${encodeURIComponent(CONTACT_BODY)}`;

export const KapaBetaSignupLink = () => (
  <Anchor
    href={contactMailtoHref}
    size="xs"
    c="white"
    fw={500}
    sx={{
      textDecoration: 'underline',
      textDecorationStyle: 'dotted',
      '&:hover': {
        textDecorationStyle: 'solid',
      },
    }}
  >
    Want help building your own agent?
  </Anchor>
);
